<template>
  <div>
    <div class="image--container"
         :style="{maxWidth: containerWidth + 'px', maxHeight: containerHeight + 'px', overflow: 'hidden'}">
      <img v-lazy="cdnUrl" :style="{width: loaded ? '100%' : (placeholderWidth + 'px')}" ref="image"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'image.component',
  props: ['src', 'default', 'width', 'height', 'force'],
  data() {
    return {
      defaultUrl: '/static/img/default/room.png',
      image: null,
      loaded: false,
    };
  },
  mounted() {
    this.image = new Image();
    this.image.src = this.cdnUrl;
    // this.image.onerror = (e) => {
    //   console.warn(`Cannot load image ${this.cdnUrl}`);
    // };
    // this.image.onload = () => {
    //   this.loaded = true;
    //   if (this.$refs.image) {
    //     this.$refs.image.src = this.cdnUrl;
    //   }
    // };
  },
  computed: {
    mainStyle() {
      if (this.force) {
        return {
          width: `${this.containerWidth}px`,
          height: `${this.containerHeight}px`,
          overflow: 'hidden',
        };
      }
      return {
        maxWidth: `${this.containerWidth}px`,
        maxHeight: `${this.containerHeight}px`,
        overflow: 'hidden',
      };
    },
    containerWidth() {
      return this.width;
    },
    containerHeight() {
      return this.height;
    },
    placeholderWidth() {
      return this.width;
    },
    cdnUrl() {
      return `${this.src}?w=${this.width}&h=${this.height}&crop-to-fit`;
    },
  },
};
</script>

<style scoped>
  .image--container {
    display: flex;
    background: #ebeced;
    overflow: hidden;
  }

  .image--container img {
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/image.component.vue